import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "flex flex-wrap justify-center gap-4 mt-10 text-sm text-center" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "No cards have been played yet.", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10 text-xl font-bold uppercase" }, "Reigning Champions", -1)
const _hoisted_6 = {
  key: 0,
  class: "flex flex-wrap justify-center text-sm text-center gap-x-4"
}

import FactionTopCardPlayers from '@/components/Faction/FactionTopCardPlayers.vue';
import { useFactionsStore } from '@/store/factions';
import {
  Faction,
  FactionReigningChampions,
  FactionScorecard,
} from '@/typings/faction';
import { onMounted, PropType, ref, toRefs } from 'vue';
import FactionBrandChampion from '@/components/Faction/FactionBrandChampion.vue';
import Spinner from '@/components/UI/Spinner.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  faction: {
    type: Object as PropType<Faction>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { faction } = toRefs(props);
const cards = ref<FactionScorecard[]>([]);
const champs = ref<FactionReigningChampions[]>([]);
const store = useFactionsStore();

const loading = ref(false);

onMounted(async () => {
  loading.value = true;
  store
    .getFactionRankedScorecards(faction.value.Uuid)
    .then((scorecards: FactionScorecard[]) => {
      cards.value = scorecards.filter((scorecard) => scorecard.Rankings.length);
      loading.value = false;
    });
  champs.value = faction.value.Champions;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!loading.value && cards.value.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(cards.value, (card) => {
            return (_openBlock(), _createBlock(FactionTopCardPlayers, {
              key: card.Title,
              card: card
            }, null, 8, ["card"]))
          }), 128))
        : (loading.value)
          ? (_openBlock(), _createBlock(Spinner, { key: 1 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
    ]),
    (_unref(faction).FactionCards?.length === 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_5,
          (champs.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(champs.value, (champ) => {
                  return (_openBlock(), _createBlock(FactionBrandChampion, {
                    key: champ.Brand,
                    "brand-champions": champ
                  }, null, 8, ["brand-champions"]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock(Spinner, { key: 1 }))
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})